module.exports = __webpack_public_path__ + "img/1.3.14.292750e1.jpg";